// extracted by mini-css-extract-plugin
module.exports = {"map":"map-component_map__3MwVw"};